<template>
    <div id="content">
        <Fundamentals />
        <CardsAgency />
        <ContentAgency />
    </div>

    <Contact />
</template>

<script>
import CardsAgency from "../components/CardsAgency.vue";
import ContentAgency from "../components/ContentAgency.vue";
import Contact from "../components/Contact.vue";
import Fundamentals from "../components/Fundamentals.vue";

export default {
    name: "Agency",
    data() {
        return {
            isMobile: false,
            displayEstimateForm: false,
        };
    },
    components: {
        CardsAgency,
        ContentAgency,
        Contact,
        Fundamentals,
    },
    created() {
        let _this = this;
        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            let homeContent = this.$refs["home-content"];
            if (homeContent) {
                let windowHeight = window.innerHeight;
                let homeContentRect = homeContent.getBoundingClientRect();
                //this.$store.dispatch("app/setPositionSticky", homeContentRect.top - windowHeight < 0 || this.isMobile ? false : true);
            }
        },
        runEstimateForm() {
            this.displayEstimateForm = !this.displayEstimateForm;
        },
        isItMobile() {
            let windowWidth = window.innerWidth;
            this.isMobile = windowWidth < 992 ? true : false;
        },
    },
};
</script>


<style lang="scss" scoped>
#content {
    padding-top: 0;
}
</style>
